import { MouseEvent } from "react";
import { useAuthContext } from "providers/Auth";
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from "shared/components/Popover";
import { ApartmentsComVariant, Unit } from "types/landlord/address";
import { ChannelAvatarRow } from "./ChannelAvatarRow";
import { SyndicationChannelTree } from "./SyndicationChannelTree";
import { useUnitSyndication } from "./useUnitSyndication";
import {
  withApartmentsComToggled,
  withApartmentsVariant,
  withDwellsyToggled,
  withZillowToggled,
  withZumperToggled
} from "./syndication";

const blockCardNavigation = (event: MouseEvent) => {
  event.preventDefault();
  event.stopPropagation();
};

const keepInsidePopover = (event: MouseEvent) => event.stopPropagation();

export const UnitChannelsPopover = ({ unit }: { unit: Unit }) => {
  const { partner, type: partnerType } = useAuthContext();
  const { syndication, defaultVariant, apply } = useUnitSyndication(unit);

  return (
    <Popover placement="bottom-start" dismissOnScroll>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label="Syndication channels"
          className="w-fit"
          onClick={blockCardNavigation}
        >
          <ChannelAvatarRow syndication={syndication} />
        </button>
      </PopoverTrigger>
      <PopoverContent
        className="z-50 w-[328px] overflow-hidden rounded-lg border border-alpha-100 bg-content-1000-inverted p-6 shadow-xl"
        onClick={keepInsidePopover}
      >
        <SyndicationChannelTree
          syndication={syndication}
          unitListed={Boolean(unit.listed)}
          hasListing={Boolean(unit.has_listing)}
          zillowEnabled={
            Boolean(partner?.zillow_connected) && partnerType.isSyndication
          }
          apartmentsComEnabled={Boolean(partner?.apartments_com_connected)}
          zumperEnabled={Boolean(partner?.zumper_connected)}
          dwellsyEnabled={Boolean(partner?.dwellsy_connected)}
          onToggleZillow={() => apply(withZillowToggled(syndication))}
          onToggleApartmentsCom={() =>
            apply(withApartmentsComToggled(syndication, defaultVariant))
          }
          onPickApartmentsVariant={(variant: ApartmentsComVariant) =>
            apply(withApartmentsVariant(syndication, variant))
          }
          onToggleZumper={() => apply(withZumperToggled(syndication))}
          onToggleDwellsy={() => apply(withDwellsyToggled(syndication))}
        />
      </PopoverContent>
    </Popover>
  );
};
